import { AppState } from '@/store/app.state';

export function getMyHedgeTrade(state: AppState) {
  return state.rollover.trade ?? state.predeliver.trade;
}
